// Slow editorial marquee
export const Marquee = ({ text = "Precision dentistry for Varanasi", dark = false }) => {
  const items = Array.from({ length: 6 });
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative flex w-full overflow-hidden border-y ${
        dark ? "border-white/10 bg-brand-accent text-white" : "border-brand-line bg-brand-soft text-brand-dark"
      } py-6`}
    >
      <div className="flex min-w-full shrink-0 animate-marquee items-center">
        {items.map((_, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8 font-display text-2xl italic md:text-4xl">{text}</span>
            <span className="text-brand-green">&#9670;</span>
          </span>
        ))}
      </div>
      <div className="flex min-w-full shrink-0 animate-marquee items-center" aria-hidden="true">
        {items.map((_, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8 font-display text-2xl italic md:text-4xl">{text}</span>
            <span className="text-brand-green">&#9670;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
